var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFunds(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.01227 11.5L11.5 11.5C12.0523 11.5 12.5 11.9477 12.5 12.5L12.5 21.9877C17.7905 21.7272 22 17.3552 22 12C22 6.47715 17.5228 2 12 2C6.6448 2 2.27278 6.20944 2.01227 11.5Z",
    fill: "#1A1B1D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.5 21.8882C6.17803 21.2381 2.76188 17.822 2.11176 13.5H10.5L10.5 21.8882Z",
    fill: "#1A1B1D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFunds);
export default __webpack_public_path__ + "static/media/funds.f3fe9e54fbb00b3e1cb396f829ea4faa.svg";
export { ForwardRef as ReactComponent };